import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const BookAddOnCheckbox = ({ onChange }) => {
  const [price, setPrice] = useState(99);
  useEffect(() => { api.get("/books/price").then((r) => setPrice(r.data.price)).catch(() => {}); }, []);

  return (
    <label className="flex items-start gap-3 py-2 cursor-pointer" data-testid="field-wants-book">
      <input type="checkbox" className="w-5 h-5 mt-0.5 shrink-0 accent-[var(--gold)]" data-testid="field-wants-book-checkbox" onChange={(e) => onChange(e.target.checked)} />
      <span className="font-body text-sm leading-relaxed" style={{ color: "var(--navy)" }}>
        Add a personalized storybook starring my child (${Number(price) % 1 ? Number(price).toFixed(2) : Number(price)} + shipping & taxes, paid separately via Zelle).{" "}
        <span style={{ color: "var(--muted)" }}>
          Coach Mimi will contact me privately for photos; my child's photos are only used with my written permission.{" "}
          <Link to="/swim-books" target="_blank" className="underline underline-offset-2" data-testid="field-wants-book-link">See the book</Link>
        </span>
      </span>
    </label>
  );
};
